// @flow

import type { Locale } from "../types/IntlTypes"
import enGB from "./en_GB.json"
import svSe from "./sv_SE.json"

const locale: Locale = {
  messages: { ...enGB, ...svSe },
  name: "sv",
}

export default locale
